"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _icon = _interopRequireDefault(require("../../Icon/icon"));

var _styler = _interopRequireDefault(require("../../Styler/styler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownSelection = function DropdownSelection(_ref) {
  var children = _ref.children,
      placeholder = _ref.placeholder,
      onClick = _ref.onClick,
      onClear = _ref.onClear,
      large = _ref.large;
  var selectionValueStyles = ['co-dropdown__value', {
    'co-dropdown__value--placeholder': !children
  }];
  return _react.default.createElement(_react.default.Fragment, null, onClear ? _react.default.createElement("button", {
    type: "button",
    className: "co-dropdown__clear",
    "aria-label": "Clear",
    onClick: onClear
  }, _react.default.createElement(_icon.default, {
    name: _icon.default.CLOSE,
    small: large
  })) : null, _react.default.createElement("div", {
    className: "co-dropdown__selection",
    onClick: onClick
  }, _react.default.createElement("input", {
    type: "hidden",
    name: "filters"
  }), _react.default.createElement(_styler.default, {
    classNames: selectionValueStyles
  }, function (styles) {
    return _react.default.createElement("span", {
      className: styles
    }, children || placeholder);
  })));
};

DropdownSelection.propTypes = {
  children: _propTypes.any,
  placeholder: _propTypes.any,
  large: _propTypes.bool,
  onClear: _propTypes.func,
  onClick: _propTypes.func
};
DropdownSelection.displayName = 'Dropdown.Selection';
var _default = DropdownSelection;
exports.default = _default;
DropdownSelection.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Dropdown.Selection",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "large": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClear": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};